<template>
    <router-view class="course-container"/>
</template>

<script>
    export default {
        data: function() {
            return {};
        }
    };
</script>

<style scoped lang="scss">
    .course-container {
        height: 100%;
        overflow: hidden;
    }
</style>
